module.exports = {"apiUrl":"/api/v2"};